import { AfterViewInit, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';

@Component({
    selector: 'fcp-progress-bar',
    templateUrl: './fcp-progress-bar.component.html',
    styleUrls: ['./fcp-progress-bar.component.less'],
    standalone: false
})
export class FcpProgressBarComponent implements OnChanges, AfterViewInit {
    @Input() progress = 0;

    @ViewChild('progress') progressElement: ElementRef<HTMLDivElement>;

    ngOnChanges() {
        this.setProgress();
    }

    ngAfterViewInit() {
        this.setProgress();
    }

    private setProgress() {
        let progress = this.progress;

        if (this.progress < 0) {
            progress = 0;
        } else if (this.progress > 100) {
            progress = 100;
        }

        if (this.progressElement) {
            this.progressElement.nativeElement.style.width = `${progress}%`;
        }
    }
}
